<template>
  <PayoutBody/>
</template>

<script>
// @ is an alias to /src
import PayoutBody from '@/components/PayoutBody.vue'

export default {
  name: 'PayoutView',
  components: {
    PayoutBody
  }
}
</script>
